const translation = {
  ABOUT_TITLE_H5: 'Apprendre à me connaître',
  ABOUT_TITLE_H2: 'À propos de moi',
  EXPERIENCE_TITLE: 'Expérience',
  EXPERIENCE_P: '2+ Années de travail',
  CLIENT_TITLE: 'Client',
  CLIENT_P: '10 Mondiale',
  PROJECT_TITLE: 'Projets',
  PROJECT_P: '20+ Complété',
  DESCRIPTION: `J'ai plus de 2 ans d'expérience, je suis expérimenté avec React et Angular en tant que technologies front-end ainsi qu'avec Node js et Nest js en tant que technologies back-end.`,
};

export default translation;
